<template>
  <v-container class="viewers-map-checker pa-4">

    <div class="checker-fixed pa-4">
      <v-row>
        <v-col cols="auto">
          <v-card color="grey lighten-3" class="py-2 px-8">
            <WidgetWebSocketControlPanel ping pong >
              <smart-btn @click.native="sendCheckMap"
                         :loading="viewersMapStatusPending"
                         :disabled="viewersMapStatusPending"
                         small>
                <v-icon small>refresh</v-icon>
                <span class="ml-1">Check</span>
              </smart-btn>

            </WidgetWebSocketControlPanel>
          </v-card>
        </v-col>
      </v-row>

      <!--MAP INFO HEADER-->
      <v-row v-if="viewersMapStatus">
        <!--MAP SUMMARY-->
        <v-col  cols="6">
          <div class="d-flex info-chip-wrapper">
            <v-tooltip top v-for="item in summaryItems" :key="item.label">
              <template #activator="{ on }">
                <v-chip v-on="on" outlined class="info-chip" color="blue lighten-1">
                  <p class="caption blue--text text--lighten-1">
                    {{ item.label }}
                  <span class="text-body-2 font-weight-medium text--darken-1">
                    {{ item.value }}
                  </span>
                  </p>
                </v-chip>
              </template>
              {{ item.tooltip }}
            </v-tooltip>
          </div>
        </v-col>

        <!--CHeck chips (consistency + joins) -->
        <v-col :cols="6">
          <v-tooltip top>
            <template #activator="{ on }">
              <v-chip v-on="on" v-if="mapHasJoinIssue" outlined class="info-chip" color="red lighten-1">
                <p class="caption red--text text--lighten-1">
                  Join Ko
                </p>
              </v-chip>
              <v-chip v-else v-on="on" outlined class="info-chip" color="green lighten-1">
                <p class="caption green--text text--lighten-1">
                  Join Ok
                </p>
              </v-chip>
            </template>
            <span>Ok si toutes les connexions ont JOIN une room</span>
          </v-tooltip>


          <v-tooltip v-if="viewersMapStatus.consistencyOk" top>
            <template #activator="{ on }">
              <v-chip v-on="on" outlined class="info-chip ml-2" color="green lighten-1">
                <p class="caption green--text text--lighten-1">
                  Cohérence Ok
                </p>
              </v-chip>
            </template>
            <span>Vérifie la cohérence des connectionId et resourceKey pour chaque connexion</span>
          </v-tooltip>
        </v-col>

        <v-col v-if="!viewersMapStatus.consistencyOk" :cols="12">
          <div class="info-chip-errors-wrapper">
            <p class="caption font-weight-bold red--text text--lighten-1">Id Ko | Incohérences</p>
            <div class="info-chip-errors">
              <p  class="caption red--text text--lighten-1" v-for="(error, index) in consistencyErrors" :key="index">
                {{ error }}
              </p>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>



    <div v-if="viewersMapStatus" class="checker-scroll">

      <!--MAP ROOMS-->
      <div class="d-flex align-center px-3 mb-2">
        <p class="headline grey--text text--darken-1 mb-0">Rooms</p>
        <span class="caption grey--text ml-1">
          ({{ rooms.length }})
        </span>
        <v-spacer />
        <smart-btn x-small secondary :disabled="!rooms.length" @click.native="openOrCloseAllRooms">
          <v-icon v-if="roomPannelAllClosed" small>unfold_more</v-icon>
          <v-icon v-else small>unfold_less</v-icon>
        </smart-btn>
      </div>

      <v-expansion-panels v-model="openedRoomPanels" v-if="rooms.length" multiple>
        <v-expansion-panel v-for="room in rooms" :key="room.resourceKey" class="room-panel">
          <v-expansion-panel-header class="room-panel-header">
            <div class="d-flex align-center flex-grow-1 room-header">
              <span class="font-weight-medium room-resource-key">
                {{ room.resourceKey }}
              </span>

              <v-spacer />

              <v-chip v-if="room.connections.filter(c => c.lastPingSentAt).length" x-small class="mr-2" color="orange lighten-4">
                {{ room.connections.filter(c => c.lastPingSentAt).length }} pong{{ room.connections.filter(c => c.lastPingSentAt).length > 1 ? "s" : "" }} attendu
              </v-chip>

              <v-chip x-small class="mr-2" color="blue lighten-4">
                {{ room.connectionCount }}
                connexion{{ room.connectionCount > 1 ? "s" : "" }}
              </v-chip>

              <v-chip x-small class="mr-3">
                {{ room.userCount }}
                utilisateur{{ room.userCount > 1 ? "s" : "" }}
              </v-chip>
            </div>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <v-simple-table dense>
              <thead>
              <tr>
                <th>Utilisateur</th>
                <th>User ID</th>
                <th>Connection ID</th>
                <th>Dernier signal</th>
                <th>Ping</th>
              </tr>
              </thead>

              <tbody>
              <tr v-for="connection in room.connections" :key="connection.connectionId">
                <td>{{ connection.firstname }} {{ connection.lastname }}</td>
                <td>{{ connection.userId }}</td>
                <td class="connection-id">{{ connection.connectionId }}</td>
                <td class="caption grey--text text--darken-1">
                  {{ connection.lastSeenAgeSeconds }} s
                </td>
                <td>
                  <v-chip x-small :color="connection.lastPingSentAt ? 'orange lighten-4' : 'green lighten-4'">
                    {{ connection.lastPingSentAt ? "Ko" : "Ok" }}
                  </v-chip>
                </td>
              </tr>
              </tbody>
            </v-simple-table>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <!-- MAP DETACHED CONNECTIONS -->
      <div v-if="detachedConnections.length" class="mt-6">
        <p class="headline red--text text--lighten-1 px-3 mb-2">
          Connexions hors room
        </p>

        <v-expansion-panels accordion>
          <v-expansion-panel class="room-panel">
            <v-expansion-panel-header class="room-panel-header">
              <div class="d-flex align-center flex-grow-1 room-header">
                <span class="subtitle-1 font-weight-medium">
                  Connexions détachées
                </span>

                <v-spacer />

                <v-chip x-small class="mr-3">
                  {{ detachedConnections.length }}
                  connexion{{ detachedConnections.length > 1 ? "s" : "" }}
                </v-chip>
              </div>
            </v-expansion-panel-header>

            <v-expansion-panel-content>
              <v-simple-table dense>
                <thead>
                <tr>
                  <th>Utilisateur</th>
                  <th>Connection ID</th>
                  <th>Dernière resourceKey</th>
                  <th>Dernier signal</th>
                </tr>
                </thead>

                <tbody>
                <tr v-for="connection in detachedConnections" :key="connection.connectionId">
                  <td>{{ connection.firstname }} {{ connection.lastname }}</td>
                  <td class="connection-id">{{ connection.connectionId }}</td>
                  <td>{{ connection.resourceKey || "—" }}</td>
                  <td class="caption grey--text text--darken-1">
                    {{ connection.lastSeenAgeSeconds }} s
                  </td>
                </tr>
                </tbody>
              </v-simple-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>

    </div>
  </v-container>
</template>


<script>
import WidgetWebSocketControlPanel from "@/components/commons/widgets/WidgetWebSocketControlPanel.vue";

export default {
  name: "ViewersMapChecker",
  components: { WidgetWebSocketControlPanel },
  inject: ["webSocketService"],
  data() {
    return {
      openedRoomPanels: [],
    }
  },
  computed: {
    status() {
      return this.webSocketService.state.status
    },
    viewersMapStatus() {
      return this.webSocketService.state.viewersMapStatus
    },
    viewersMapStatusPending() {
      return this.webSocketService.state.viewersMapStatusPending
    },
    mapHasJoinIssue() {
      return this.viewersMapStatus.totalConnections !== this.viewersMapStatus.joinedConnections
    },
    summaryItems() {
      if (!this.viewersMapStatus) { return [] }

      return [
        {
          label: "Connexions",
          value: this.viewersMapStatus.totalConnections,
          tooltip: "Les onglets/connexions dans la map. (map size)."
        },
        {
          label: "Rooms",
          value: this.viewersMapStatus.resourceCount,
          tooltip: "Représente un même lieu, attaché à une resourceKey (ex: vente/dossier/12345)"
        },
        {
          label: "Dans une room",
          value: this.viewersMapStatus.joinedConnections,
          tooltip: "Les connexion avec join à true"
        },
        {
          label: "Hors room",
          value: this.viewersMapStatus.leftConnections,
          tooltip: "Les connexion avec join à false"
        },
        {
          label: "Pong en attente",
          value: this.viewersMapStatus.pendingPongCount,
          tooltip: "Représente le nombre de connexion n'ayant pas encore répondu au heartbeat serveur"
        }
      ]
    },
    consistencyErrors() {
      if (!this.viewersMapStatus || !Array.isArray(this.viewersMapStatus.consistencyErrors)) { return [] }
      return this.viewersMapStatus.consistencyErrors
    },
    rooms() {
      const viewers = this.viewersMapStatus && Array.isArray(this.viewersMapStatus.viewers)
            ? this.viewersMapStatus.viewers
            : []

      const viewersByResourceKey = viewers
          .filter(viewer => viewer.joined)
          .reduce((rooms, viewer) => {
            const resourceKey = viewer.resourceKey || "no resourceKey"
            if (!rooms[resourceKey]) { rooms[resourceKey] = [] }
            rooms[resourceKey].push(viewer)
            return rooms
          }, {})

      return Object.keys(viewersByResourceKey)
          .sort()
          .map(resourceKey => {
            const connections = viewersByResourceKey[resourceKey]

            return {
              resourceKey,
              connections,
              connectionCount: connections.length,
              userCount: new Set(connections.map(connection => connection.userId)).size
            }
          })
    },
    detachedConnections() {
      if (!this.viewersMapStatus || !Array.isArray(this.viewersMapStatus.viewers)) {
        return []
      }

      return this.viewersMapStatus.viewers
          .filter(viewer => !viewer.joined)
          .sort((a, b) => a.connectionId.localeCompare(b.connectionId))
    },
    roomPannelAllClosed() {
      return this.openedRoomPanels.length === 0
    }
  },
  methods: {
    sendCheckMap() { this.webSocketService.sendCheckMap() },
    openOrCloseAllRooms() {
      if (this.roomPannelAllClosed) {
        this.expandAllRooms()
      } else {
        this.collapseAllRooms()
      }
    },
    expandAllRooms() {
      this.openedRoomPanels = this.rooms.map((room, index) => index)
    },
    collapseAllRooms() {
      this.openedRoomPanels = []
    },
  }, // [N] end methods
}
</script>


<style scoped>
.viewers-map-checker {
  height: calc(100vh - 96px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.checker-fixed {
  flex: 0 0 auto;
}

.checker-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 4px 8px 24px 0;
}

.room-panel-header {
  padding: 0 16px;
  max-height: 28px;
}

::v-deep .room-panel-header {
  min-height: 28px !important;
  padding: 4px 16px !important;
}

.room-panel {
  margin-bottom: 4px;
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.room-header {
  min-width: 0;
}

.room-resource-key {
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.connection-id {
  font-family: monospace;
  font-size: 12px;
}

.info-chip {
  border-radius: 4px;
  cursor: pointer;
}

.info-chip-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  user-select: none;
}

.info-chip-errors-wrapper {
  padding: 4px 12px;
  border-radius: 6px;
  border: 1px solid #EF5350;
}

.info-chip-errors {
  border-top: 1px solid #EF5350;
  min-height: 50px;
  max-height: 220px;
  overflow-y: auto;
}
</style>